import React from 'react';
import { css } from '@emotion/core';
import '../../../../styles/variables.scss';
import Link from '../../Link/Link';
const helpStyle = css`
  color: #ffff;
  font-size: 12px;
  @media screen and (max-width: 567px) {
    font-size: 9px;
  }

  font-weight: 400;
  display: block;
  cursor: pointer;
  &:hover, &:focus, &: active {
    text-decoration: none;
    color: #ffff;
  }
`;
const Help = () => {
  return (
    <Link to="/pagine/contattaci" className="help" css={helpStyle}>
      Hai bisogno d'aiuto?
    </Link>
  );
};
export default Help;
